import { render, staticRenderFns } from "./CheckCode.vue?vue&type=template&id=f9c80e22"
import script from "./CheckCode.vue?vue&type=script&lang=js"
export * from "./CheckCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports